<template>
  <div v-if="isMobile" class="live-detail">
    <div v-show="!isShowLogin" class="player" :style="{ width: `${width}px`, height: `${height}px` }">
      <!-- <m-player
        ref="player"
        v-if="(detail.liveStatus === 0 || haveVideo === true) && !isShowLogin"
        :src="detail.livePlayHlsUrl"
        :live="detail.liveStatus === 0"
        :liveStatus="detail.liveStatus"
        :flag="flag"
      /> -->
      <node-player
        ref="player"
        :src="detail.livePlayHlsUrl"
        :live="true"
        :end="liveEnd"
        @onFullScreen="handleFullScreen"
        @onError="urlError"
      />
      <!-- <div v-else class="course-tip">
        {{ tips }}
      </div> -->
    </div>
    <comments
      v-if="!isFullScreen"
      ref="comments"
      :live="detail"
      :isVisitor="true"
      @playVideo="handleVideoChange"
      @checkLogin="checkLogin"
      @handleToLogin="handleToLogin"
    />
    <div v-if="!isFullScreen" class="float-operation">
      <m-suspend-button :top="400" text="" @onSuspendBtnClick="share">
        <img v-if="detail.liveStatus !== 2" alt src="@/assets/living-share.png" slot="icon" />
      </m-suspend-button>
      <m-suspend-button :top="460" :text="praiseCount.toString()" @onSuspendBtnClick="praise">
        <img
          v-if="detail.liveStatus == 2 || !visitorInfo"
          src="@/assets/living-like-none.png"
          slot="icon"
        />
        <img v-else src="@/assets/living-like.png" slot="icon" />
      </m-suspend-button>
    </div>
    <share-login
      :isShowLogin="isShowLogin"
      @changeShowLogin="changeShowLogin"
      ref="popup"
      @hide="resetPlay"
    />

    <img
      v-if="!isFullScreen"
      class="watermark"
      src="@/assets/watermark/watermark.png"
      slot="icon"
      :style="{
        position: 'absolute',
        left: '0px',
        bottom: '160px',
        transform: 'rotate(-45deg)',
        width: `${watermarkWidth}px`,
        opacity: 0.3
      }"
    />
  </div>
  <div v-else class="live-detail-pc">
    <div class="pc-title">
      <div style="display:flex; align-items: center;">
        <img src="@/assets/live-icon0.png" alt="" />
        <span>{{ detail.liveTitle }}</span>
      </div>
      <div class="pc-live-count">
        <div>{{ isNaN(detail.viewCount + 1) ? 0 : detail.viewCount + 1 }}人次观看</div>
      </div>
    </div>
    <div class="pc-palyer-comment">
      <div class="pc-player">
        <NodePlayerPC
          ref="player-pc"
          :src="detail.livePlayHlsUrl"
          :live="true"
          :end="liveEnd"
          @onFullScreen="handleFullScreen"
          @onError="urlError"
        />
      </div>
      <div class="pc-comment">
        <!-- <CommentsPC
          v-if="!isFullScreen"
          ref="comments"
          :live="detail"
          :isVisitor="true"
          @playVideo="handleVideoChange"
          @checkLogin="checkLogin"
          @handleToLogin="handleToLogin"
        /> -->
        <div class="pc-live-info">
          <img style="border-radius: 50%;" :src="detail.avatar" class="pc-user-avtar" />
          <div class="pc-user-date">
            <div class="pc-live-user">{{ detail.userName }}</div>
            <div class="pc-live-date">{{ detail.startTime | formatDate('YYYY-MM-DD HH:mm') }}</div>
          </div>
          <!-- <div class="pc-live-count">
            <div>{{ isNaN(detail.viewCount + 1) ? 0 : detail.viewCount + 1 }}人次观看</div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="pc-live-info-bottom">
      <!-- <img style="border-radius: 50%;" :src="detail.avatar" class="pc-user-avtar" />
      <div class="pc-user-date">
        <div class="pc-live-user">{{ detail.userName }}</div>
        <div class="pc-live-date">{{ detail.startTime | formatDate('YYYY-MM-DD HH:mm') }}</div>
      </div>
      <div class="pc-live-count">
        <div>{{ isNaN(detail.viewCount + 1) ? 0 : detail.viewCount + 1 }}人次观看</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MPlayer from '@/components/MPlayer/IndexCode.vue';
import NodePlayer from '@/components/MPlayer/nodePlayer.vue';
import NodePlayerPC from '@/components/MPlayer/nodePlayerPC.vue';
import liveApi from '@/api/live';
import playerMixin from '@/mixins/player';
import MSuspendButton from '@/components/MSuspendButton/IndexCode.vue';
import liveMixin from '@/mixins/liveCode';
import Comments from './commentsCode';
import CommentsPC from './commentsCodePC';
import ShareLogin from '@/pages/ShareLogin/index.vue';
// import CountDown from '@/components/Live/CountDown.vue';
import api from '@/api/app';
import Cookies from 'js-cookie';
import { isMobile } from '@/utils/index.js';

export default {
  name: 'live-share-code',
  components: {
    MPlayer,
    NodePlayer,
    NodePlayerPC,
    Comments,
    CommentsPC,
    MSuspendButton,
    ShareLogin
    // CountDown
  },
  data() {
    return {
      mobile: '',
      // detail: {},
      haveVideo: false,
      videoPlaying: false,
      isStart: false,
      liveEnd: false,
      detail: {
        id: '',
        liveId: '',
        title: '',
        userName: '',
        livePath: '',
        liveStatus: '',
        isLiveServer: '',
        viewCounts: '',
        startTime: '',
        livePassword: ''
      },
      schoolName: '',
      streamStatus: false,
      praiseCount: 0,
      isPraise: false,
      isShowLogin: false,
      flag: true,
      liveInfoInterval: null,
      isLogin: true,
      detailInfoInterval: null,
      watermarkWidth: 0,
      isFullScreen: false,
      isMobile: false
    };
  },
  mixins: [playerMixin, liveMixin],
  computed: {
    tips() {
      let tip2048 = '';
      if (this.detail.liveStatus === 1) {
        tip2048 = '未推流,请等待直播推流';
      } else if (this.detail.liveStatus === 2) {
        tip2048 = '直播已结束';
      }
      return tip2048;
    },
    ...mapGetters(['userInfo', 'visitorInfo'])
  },
  created() {
    this.isMobile = isMobile();
  },
  mounted() {
    this.watermarkWidth = document.body.clientWidth;
    const user = global.localStorage.getItem('userInfo');
    if (user && user.uid) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
    console.log('this.isLogin', this.isLogin);
    this.getLiveDetail();
    // this.checkLogin();
    this.mobile = this.mobile ? this.mobile : localStorage.getItem('mobile');
    // if (!this.mobile) {
    //   return;
    // }
    if (this.$route.meta.refresh === null) {
      api
        .fetchUserInfo({
          mobile: this.mobile ? this.mobile : localStorage.getItem('mobile')
        })
        .then(response => {
          // if (response.result.success) {
          if (response.code === 0) {
            // this.$store.commit('SET_USER_INFO', response.result.data);//php后端
            this.$store.commit('SET_USER_INFO', response.result);
            // 直播，判断当前学校有无权限
            this.checkSchoolAuth();
            this.getLiveList();
            let userInfo = response.result;
            api
              .getUserSign({
                userId: userInfo.uid
              })
              .then(resSig => {
                console.log('res:getUserSign ', resSig);
                userInfo = { ...userInfo, ...resSig.result };
                global.localStorage.setItem('userInfo', JSON.stringify(userInfo));
                // window.localStorage['loginInfo'] = JSON.stringify(loginInfo);
                if (this.deviceUuid) {
                  // this.$store.commit('SET_USER_INFO', response.result.data);//php后端
                  this.$store.commit('SET_USER_INFO', userInfo);
                } else {
                  this.$store.commit('SET_VISITOR_INFO', userInfo);
                  global.localStorage.setItem('visitorInfo', JSON.stringify(userInfo));
                }
              });
          } else {
            Cookies.remove('vuex');
            this.changeLoadingStatus(false);
            this.$createToast({
              // txt: response.result.message || '该用户不存在',
              txt: response.other.msg || '该用户不存在',
              type: 'text'
            }).show();
          }
        })
        .catch(error => {
          console.log('getUserInfo error = ', error);
        });
      this.$route.meta.refresh = false;
      return;
    }
    this.liveInfoInterval = setInterval(() => {
      this.getInfo();
    }, 1000 * 30);
  },
  destroyed() {
    clearInterval(this.liveInfoInterval);
  },
  methods: {
    handleToLogin() {
      this.$refs.popup.show(true);
    },
    share() {
      this.$store.commit('SET_CURRENT_LIVE_ITEM', this.detail);
      let mobile = this.userInfo.mobile;
      this.$router.push(
        `/share?liveId=${this.detail.liveId}&schoolName=${this.detail.schoolName}&streamStatus=${
          this.detail.streamStatus
        }&mobile=${mobile}`
      );
    },
    getInfo() {
      let schoolName = this.$route.params.schoolName;
      // 推流状态
      if (typeof this.$route.params.streamStatus != 'undefined') {
        this.streamStatus = this.$route.params.streamStatus;
      }
      const params = {
        liveId: this.liveId,
        schoolName: schoolName
      };
      liveApi.fetchLiveCodeDetailForStatus(params).then(response => {
        if (response.code === 0) {
          this.detail.livePlayHlsUrl = response.result.livePlayHlsUrl;
          this.detail.liveStatus = response.result.liveStatus;
        }
      });
    },
    getTotalPraise() {
      let params = {
        id: this.detail.liveId,
        type: 1
      };
      liveApi.fetchLivePraiseCount(params).then(res => {
        if (res.code === 0) {
          this.praiseCount = res.result;
        }
      });
    },
    praise() {
      if (this.detail.liveStatus === 2) {
        this.$createToast({
          txt: '直播已结束',
          type: 'warn'
        }).show();
        return;
      }
      let visitorInfo = JSON.parse(global.localStorage.getItem('visitorInfo'));
      let userInfo = JSON.parse(global.localStorage.getItem('userInfo'));
      if (userInfo) {
        this.mobile = userInfo.mobile;
      } else if (!visitorInfo && !userInfo) {
        const shareLive = this.$refs.popup;
        shareLive && shareLive.show(true);
        return;
      } else {
        this.mobile = visitorInfo.mobile;
      }
      let params = {
        id: this.detail.liveId,
        mobile: this.mobile,
        schoolName: this.detail.schoolName,
        type: 1
      };
      liveApi.addPraise(params).then(res => {
        if (res.result === true) {
          this.$createToast({
            txt: '点赞成功',
            type: 'success'
          }).show();
          // 获取点赞总数
          this.getTotalPraise();
        } else {
          this.$createToast({
            txt: '点赞失败',
            type: 'error'
          }).show();
        }
      });
    },
    changeShowLogin(flag) {
      this.isShowLogin = flag;
    },
    handleVideoChange(params) {
      const { url } = params;
      if (params.index === 0) {
        if (this.detail.liveStatus === 0) {
          this.flag = true;
          this.haveVideo = true;
          this.videoPlaying = true;
          setTimeout(() => {
            // this.$refs.player.live = true;
            this.$refs.player.living = true;
            this.$refs.player.haveVideo = true;
            this.$refs.player.url = url;
            this.$refs.player.initPlayer();
          }, 300);
        } else {
          this.haveVideo = false;
        }
      } else {
        this.flag = false;
        this.haveVideo = true;
        this.videoPlaying = true;
        setTimeout(() => {
          // this.$refs.player.live = false;
          this.$refs.player.living = false;
          this.$refs.player.haveVideo = true;
          this.$refs.player.url = url;
          this.$refs.player.initPlayer();
        }, 300);
      }
    },
    tolive() {
      const url = this.detail.livePlayHlsUrl;
      if (this.detail.liveStatus === 2 || this.detail.liveStatus === 1) {
        this.haveVideo = false;
        this.videoPlaying = false;
      } else {
        this.videoPlaying = false;
        this.$refs.player.haveVideo = false;
        this.$refs.player.url = url;
        this.$refs.player.initPlayer();
      }
    },
    getLiveDetail(isPraise) {
      let schoolName = this.$route.params.schoolName;
      // 推流状态
      if (typeof this.$route.params.streamStatus != 'undefined') {
        this.streamStatus = this.$route.params.streamStatus;
      }
      const params = {
        liveId: this.liveId,
        schoolName: schoolName
      };
      liveApi.fetchLiveCodeDetail(params).then(response => {
        if (response.code === 0) {
          this.detail = response.result;
          document.title = this.detail.liveTitle;
          if (this.detail.videoList === '') {
            this.detail.videoList = [];
          }
          // this.detail.liveStatus = 1;
          console.log('this.detail', this.detail);

          if (this.detail.liveStatus === 1) {
            this.getLiveDetail();
          } else if (this.detail.liveStatus === 2) {
            this.liveEnd = true;
          } else if (!isPraise) {
            if (response.result.liveStatus !== 2) {
              this.addViews();
            }
          }
        }
      });
    },
    addViews() {
      const params = {
        liveId: this.liveId
      };
      liveApi.addViewsCode(params);
    },
    showLogin() {
      this.$refs.popup.show(true);
      // this.$refs.player && this.$refs.player.pause();
      this.$refs.player && this.$refs.player.stopPlayer();
    },
    resetPlay() {
      let visitorInfo = JSON.parse(global.localStorage.getItem('visitorInfo'));
      // this.$refs.player && this.$refs.player.play();
      this.$refs.player && this.$refs.player.startPlayer();
      if (visitorInfo.mobile) {
        this.getLiveDetail();
      }
    },
    endHandler() {
      this.isStart = true;
    },
    checkLogin() {
      console.log(3333333);
      if (!window.localStorage) {
        alert('浏览器不支持localstorage');
      } else {
        const currentTime = new Date().getTime();
        const storage = window.localStorage;
        if (!storage.mobile || currentTime >= storage.outTime) {
          this.logined = false;
          window.localStorage['mobile'] = '';
          // 需要登录
          this.$refs.popup.show(false, this.deviceUuid);
          return;
        }
      }
    },
    urlError() {
      // this.isStart = false;
      this.tips = this.liveEnd ? '老师已下课，谢谢观看' : '休息一下，等老师回来';
      if (this.tips === '老师已下课，谢谢观看') {
        this.isStart = false;
      }
    },
    handleFullScreen(isFullScreen) {
      this.isFullScreen = isFullScreen;
    },
  },
  watch: {
    'detail.liveId'() {
      this.getTotalPraise();
    },
    'detail.liveStatus'() {
      this.isStart = this.detail.liveStatus === 1;
    }
  }
};
</script>

<style lang="less" scoped>
.live-detail {
  position: relative;

  /* 悬浮按钮 */

  .float-operation {
    position: fixed;
    top: 460px !important;
    width: 65px !important;
    right: 15px !important;
    z-index: 99;
    text-align: center;
  }

  .float-operation img {
    width: 62px;
    height: 62rpx;
    margin-bottom: -10px;
    opacity: 0.9;
  }

  .gray {
    color: #949494 !important;
  }

  .float-operation span {
    display: block;
    margin-top: 10px;
    position: relative;
    color: #ffc329;
  }

  .share-btn {
    padding: 0;
    border: 0;
    background-color: #fff;
    margin-bottom: -10px;
  }

  .share-btn::after {
    border: 0;
  }

  button[plain] {
    border: 0;
  }

  .player {
    background: #000;
    .course-tip {
      font-size: 14px;
      color: #ccc;
      // padding-top: 90px;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .liveto {
    position: absolute;
    right: 15px;
    top: 18px;
    z-index: 1000001;
    font-size: 12px;
    color: #fff;
  }
}

.live-detail-pc {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  height: 100vh;

  .pc-title {
    text-align: left;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    font-size: 6px;
    border-bottom: 0.5px solid #eee;

    .pc-live-count {
      height: 12px;
      font-size: 4px;
      color: #fff;
      margin-left: 6px;
      margin-top: 4px;

      div {
        background: #1980ff;
        border-radius: 16px;
        padding: 1px 2px;
      }
    }

    img {
      height: 10px;
      margin-right: 6px;
    }
  }

  .pc-palyer-comment {
    flex: 1;
    display: flex;

    .pc-player {
      width: 75%;
    }

    .pc-comment {
      width: 25%;
      height: 100%;
    }
  }

  .pc-live-info {
    text-align: left;
    height: 20px;
    display: flex;
    align-items: center;
    padding-left: 5px;

    .pc-user-avtar {
      height: 12px;
      margin-right: 6px;
    }

    .pc-praise-img,
    .pc-share-img {
      height: 12px;
    }

    .pc-user-date {
      display: flex;
      flex-direction: column;
      justify-content: space-around !important;
      height: 12px;

      .pc-live-user {
        font-size: 4px;
      }
      .pc-live-date {
        font-size: 4px;
      }
    }

    .pc-live-count {
      height: 12px;
      font-size: 4px;
      color: #fff;
      margin-left: 6px;

      div {
        background: #1980ff;
        border-radius: 16px;
        padding: 1px 2px;
      }
    }
  }

  .pc-live-info-bottom {
    text-align: left;
    height: 20px;
    display: flex;
    align-items: center;
    padding-left: 10px;

    .pc-user-avtar {
      height: 12px;
      margin-right: 6px;
    }

    .pc-praise-img,
    .pc-share-img {
      height: 12px;
    }

    .pc-user-date {
      display: flex;
      flex-direction: column;
      justify-content: space-around !important;
      height: 12px;

      .pc-live-user {
        font-size: 4px;
      }
      .pc-live-date {
        font-size: 4px;
      }
    }

    .pc-live-count {
      height: 12px;
      font-size: 4px;
      color: #fff;
      margin-left: 6px;

      div {
        background: #1980ff;
        border-radius: 16px;
        padding: 1px 2px;
      }
    }
  }
}
</style>
